import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { baseUrl, route } from "../../App";
import { StellaBIOExternal } from "./stella-bio-external";
import { StellaBIOFlash } from "./stella-bio-flash";
import { StellaBIOInstallTablet } from "./stella-bio-install-tablet";
import { StellaBIOOrder } from "./stella-bio-order";
import { StellaBIOSerialNumber } from "./stella-bio-serial-number";
import "./styles.scss";
import { StellaBIOReprint } from "./stella-bio-reprint";

export function StellaBIOHome(props: RoutableProps) {
    return <div class="stella-bio-page">
        <h1 style="text-align: center; font-size: 30px; margin-top: 10px;">Wybierz akcje</h1>
        <div class="paper action-list">
            <div class="product-list" style="margin-top: 10px;">
                <div class="action-button" onClick={() => route("/stella-bio/flash")}>
                    <span class="icon">developer_board</span>
                    <div class="action">Zaprogramuj StellaBIO</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/stella-bio/serial-number")}>
                    <span class="icon">confirmation_number</span>
                    <div class="action">Wygeneruj numery seryjne dla akcesoriów</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/stella-bio/reprint")}>
                    <span class="icon">view_agenda</span>
                    <div class="action">Wydrukuj naklejkę dla istniejącego numeru</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/stella-bio/external")}>
                    <span class="icon">devices</span>
                    <div class="action">Zarejestruj urządzenia zewnętrzne</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/stella-bio/install-tablet")}>
                    <span class="icon">tablet_mac</span>
                    <div class="action">Zainstaluj oprogramowanie tabletu</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/batch-lot-register")}>
                    <span class="icon">
                        <svg width="50" height="50">
                            <rect x="11" y="15" width="28" height="20" rx="3" style="stroke: #efefef; stroke-width: 3px; fill: none"></rect>
                            <text x="25" y="30" style="font-family: Arial; font-size: 11px; font-weight: bold; fill: white; text-anchor: middle;">LOT</text>
                        </svg>
                    </span>
                    <div class="action">Wprowadź nową partię</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/stella-bio/order")}>
                    <span class="icon">post_add</span>
                    <div class="action">Stwórz zestawienie</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/order")}>
                    <span class="icon">list_alt</span>
                    <div class="action">Pokaż zestawienia</div>
                    <span class="icon">chevron_right</span>
                </div>
            </div>
        </div>
    </div>;
}

export function StellaBIO(props: RoutableProps) {
    return <Router>
        <StellaBIOHome path={`${baseUrl}/stella-bio`}/>
        <StellaBIOSerialNumber path={`${baseUrl}/stella-bio/serial-number`}/>
        <StellaBIOReprint path={`${baseUrl}/stella-bio/reprint`}/>
        <StellaBIOFlash path={`${baseUrl}/stella-bio/flash`}/>
        <StellaBIOOrder path={`${baseUrl}/stella-bio/order/:id?`}/>
        <StellaBIOExternal path={`${baseUrl}/stella-bio/external`}/>
        <StellaBIOInstallTablet path={`${baseUrl}/stella-bio/install-tablet`}/>
    </Router>
}
